import { useTranslation } from 'react-i18next';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { computed } from 'mobx';
import { getUrlWithScheme } from '../../../../../utils';
import { Button, ButtonType } from '../../../../Button';

interface Props {
  partnerLogo: string;
  partnerUrl: string;
}

export const CreditlessPartnerWidget = ({ partnerLogo, partnerUrl }: Props): JSX.Element => {
  const { t } = useTranslation();

  const urlWithScheme = computed(() => getUrlWithScheme(partnerUrl)).get();

  const handleClick = (): void => {
    const newWindow = window.open(urlWithScheme, '_blank');
    newWindow?.focus();
  }

  return (
    <WidgetCard
      logo={partnerLogo}
      logoAlt={t('dashboard.widgets.creditlessPartner.activityHero.logoAlt')}
      description={t('dashboard.widgets.creditlessPartner.activityHero.description')}
      hasButton
      buttonComponent={<Button
          buttonType={ButtonType.secondary}
          onClick={handleClick}>{t('dashboard.widgets.creditlessPartner.learnMore')}
        </Button>
      }
    />
  );
};
